// HistorialConsolidado.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseMutationsParams } from "@/shared/interfaces";
import { urlBackend } from "@/shared/constants";
import { toApiError } from "@/shared/utils/general";
import { HistorialConsolidadoForm, HistorialConsolidadoResponse } from '@/shared/interfaces/erp/contrato/historial_consolidado.interface';
import axios from 'axios';
import { useAuthStore } from '@/store/auth';
import { erpApi } from '@/shared/axios/erp-api';

// create 

export const postHistorialConsolidado = async (
  data: HistorialConsolidadoForm
) => {
  const token = useAuthStore.getState().token;
  const formData = new FormData();

  formData.append('file', data.file);
  formData.append('para', data.para);
  formData.append('asunto', data.asunto);
  formData.append('mensaje', data.mensaje);
  formData.append('documentos', data.documentos);
  formData.append('contrato', data.contrato);

  const response = await axios.post(
    `${urlBackend}api/v1/enviar-correo-consolidado/`,
    formData,
    {
      headers: {
        'Authorization': `Token ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};

// get

export const getHistorialConsolidado = async (contratoCodigo?: string) => {
  const { get } = erpApi();
  const query = contratoCodigo
    ? `?contrato=${encodeURIComponent(contratoCodigo)}`
    : '';

  const response = await get<HistorialConsolidadoResponse>(
    `${urlBackend}api/v1/historial-consolidado/${query}`,
    true
  );

  console.log(response);
  
  return response;
};

export const useFetchGetHistorialConsolidado = (
  contratoCodigo?: string,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['historial-consolidado', contratoCodigo],
    queryFn: () => getHistorialConsolidado(contratoCodigo),
    enabled: enabled && !!contratoCodigo,
  });
};

export const useFetchPostHistorialConsolidado = ({
  returnUrl,
  navigate,
}: UseMutationsParams = {}) => {
  return useMutation({
    mutationFn: postHistorialConsolidado,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['documentacion'],
      });

      navigate && returnUrl && navigate(returnUrl);
      toast.success(data.message || 'Archivos subidos correctamente');
    },
    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });
};